import type { NetworkUnit } from "@/services/types"

/* ─────────────────────────────────────────────────────────────────────────────
 * Traducao dos arquivos locais para o modelo de dominio.
 *
 * Os JSONs vieram do prototipo com chaves em portugues e no formato da planilha
 * de origem. Em vez de propagar `atende_regioes` por toda a UI, a conversao
 * acontece aqui — no mesmo lugar em que o adapter da API vai converter o
 * payload dele. Nenhum componente conhece o formato de nenhuma fonte.
 * ────────────────────────────────────────────────────────────────────────── */

interface RawNetworkUnit {
  id: number
  tipo: string
  nome: string
  crmv: string
  email: string | null
  telefone: string | null
  whatsapp: string | null
  endereco: string
  bairro: string | null
  cidade: string
  estado: string
  cep: string
  horario: string
  especialidades: string[]
  atende_regioes: string[]
  h24: boolean
}

export function toNetworkUnit(raw: RawNetworkUnit): NetworkUnit {
  return {
    id: raw.id,
    kind: raw.tipo === "PJ" ? "PJ" : "PF",
    name: raw.nome,
    crmv: raw.crmv,
    email: raw.email,
    phone: raw.telefone,
    whatsapp: raw.whatsapp,
    address: raw.endereco,
    district: raw.bairro,
    city: raw.cidade,
    state: raw.estado,
    postalCode: raw.cep,
    openingHours: raw.horario,
    specialties: raw.especialidades,
    servedRegions: raw.atende_regioes,
    open24h: raw.h24,
  }
}

/** Remove tudo que nao e digito. Compara CEP com e sem mascara. */
export function onlyDigits(value: string): string {
  return value.replace(/\D/g, "")
}
